(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "normalizr", "../setting"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("normalizr"), require("../setting"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.normalizr, global.setting);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _normalizr, _setting) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.locationsSchema = _exports.locationSchema = void 0;

  /**
   * Schema for a single location
   * @type {schema.Entity}
   */
  var locationSchema = new _normalizr.schema.Entity(_setting.locationEntityKey);

  /**
   * Schema for multiple locations
   * @type {Array<schema.Entity>}
   */
  _exports.locationSchema = locationSchema;
  var locationsSchema = [locationSchema];
  _exports.locationsSchema = locationsSchema;
});